import CardWrapper from '../card-wrapper';
import Step01Image from '../../../../../assets/images/memory/onboarding/step-01.png';
import { Typography } from '../../../../../core/components/molecules/Typography';
import StepButton from '../step-button';
import { RocketLaunchIcon } from '../../../../../assets/icons/rocket-launch';

const Step01 = ({ onNextStep }: { onNextStep: () => void }) => {
  return (
    <CardWrapper.Root side='right' className='my-10'>
      <CardWrapper.Primary className='flex flex-col items-center justify-center px-5'>
        <div className='flex flex-col items-center justify-center gap-4'>
          <Typography
            title='h1'
            className='!text-h1 font-bold text-mono-color-darker'
          >
            Domine seus estudos com <i>Flashcards</i> Inteligentes
          </Typography>
          <Typography
            title='h1'
            className='!text-md !font-normal text-mono-color-darker'
          >
            Aqui você organiza seus conteúdos em Decks, revisa no momento certo
            e acompanha a dificuldade de cada tema. Tudo para você aprender mais
            rápido — e lembrar por muito mais tempo.
          </Typography>
        </div>
        <div className='mt-4 flex w-full justify-end'>
          <StepButton
            label='Iniciar'
            onClick={onNextStep}
            icon={<RocketLaunchIcon />}
          />
        </div>
      </CardWrapper.Primary>

      <CardWrapper.Secondary className='w-full rounded-lg md:w-[554px]'>
        <img
          src={Step01Image}
          alt='Step 01'
          className='h-full w-full rounded-lg md:object-contain'
        />
      </CardWrapper.Secondary>
    </CardWrapper.Root>
  );
};

export default Step01;
